export const BENEFIT_SUBMITTED = 'benefits/BENEFIT_SUBMITTED';
